import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmClass, } from "../model/index.js";
export async function executeDataPsmSetInstancesSpecifyTypes(reader, createNewIdentifier, operation) {
    const resource = await reader.readResource(operation.dataPsmClass);
    if (resource == null) {
        return CoreExecutorResult.createError(`Missing data-psm resource '${operation.dataPsmClass}'.`);
    }
    if (!DataPsmClass.is(resource)) {
        return CoreExecutorResult.createError("Invalid resource type.");
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...resource,
            instancesSpecifyTypes: operation.instancesSpecifyTypes,
        }
    ]);
}
//# sourceMappingURL=data-psm-set-instances-specify-type.js.map